function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import Logger from "../../utils/logger";
import Axios from "axios";
import { useContext, useState, useEffect } from "react";
import FirebaseContext from "./firebaseContext";
import { politicalParties, result as resultEndPoint } from "../../constants/api";
import { PATH, TYPES } from "../../envs/core";
import useRESTDataCache from "../hooks/useRESTDataCache";
import { arrayToDict, LA_SEXTA } from "../../utils";
export const ResultProvider = ({
  active,
  year,
  type,
  subtype = "SINGLE",
  electionNumber,
  placeId = "C108",
  electionPlace,
  children,
  onlyWinners = false,
  details = false,
  customPath
}) => {
  Logger.log("ResultProvider", "Nuevo render del result provider");

  const _useContext = useContext(FirebaseContext),
        app1 = _useContext.app1,
        app2 = _useContext.app2,
        app3 = _useContext.app3,
        firebase = _useContext.firebase;

  const _useState = useState({}),
        _useState2 = _slicedToArray(_useState, 2),
        result = _useState2[0],
        setResult = _useState2[1];

  const host = window.location.hostname.replace("localhost", "lasexta");
  const isLaSexta = host.includes(LA_SEXTA);
  const matchParties = useRESTDataCache("".concat(PATH).concat(politicalParties, "?year=").concat(year, "&typeElection=").concat(type, "&numElection=").concat(electionNumber, "&regionId=R09"));
  useEffect(() => {
    setResult({});
    changeSubscribtion();
    return () => result.currentResultRef && result.currentResultRef().off();
  }, [active, type, subtype, year, electionNumber, placeId, matchParties]);

  const getFirebaseData = (resultRefs, success, error) => {
    if (resultRefs.length > 0) {
      resultRefs[0]().on("value", dataResult => {
        success({
          resultRef: resultRefs[0],
          data: dataResult.val()
        });
      }, err => {
        resultRefs.pop();
        getFirebaseData(resultRefs, success, error);
      });
    } else {
      error(success);
    }
  };

  const changeSubscribtion = () => {
    if (result.currentResultRef) {
      result.currentResultRef().off();
    }

    const electionPlacePath = type === TYPES.REGIONAL ? "/".concat(electionPlace) : "";
    const firebasePath = customPath || (!details ? "".concat(year, "/").concat(type, "/").concat(subtype, "/").concat(electionNumber).concat(electionPlacePath, "/TOTALS/").concat(placeId) : "".concat(year, "/").concat(type, "/").concat(subtype, "/").concat(electionNumber).concat(electionPlacePath, "/TOWNS/").concat(placeId));
    Logger.log("changeSubscribtion", "| firebase path: ".concat(firebasePath));

    const resultRef = () => firebase.database(app1).ref(firebasePath);

    const resultRef2 = () => firebase.database(app2).ref(firebasePath);

    const resultRef3 = () => firebase.database(app3).ref(firebasePath);

    const successFunction = ({
      data: dataResult,
      resultRef: currentResultRef
    }) => {
      let partyFormats = [];

      if (matchParties) {
        partyFormats = arrayToDict(matchParties, "currentId");
      }

      if (dataResult) {
        dataResult.abstentionPercent = dataResult.abstentionPercent ? dataResult.abstentionPercent.toFixed(2) : 0;
        dataResult.currentCountPercent = dataResult.currentCountPercent ? dataResult.currentCountPercent.toFixed(2) : 0;
        dataResult.invalidPercent = dataResult.invalidPercent ? dataResult.invalidPercent.toFixed(2) : 0;
        dataResult.participationPercent = dataResult.participationPercent ? dataResult.participationPercent.toFixed(2) : 0;
        dataResult.whitePercent = dataResult.whitePercent ? dataResult.whitePercent.toFixed(2) : 0;
        dataResult.partiesResult = dataResult.partiesResult ? dataResult.partiesResult // .filter(result => result.votesPercent)
        .map(result => {
          const partyFormat = partyFormats[result.id];
          return _objectSpread({}, result, {
            votesPercent: result.votesPercent ? parseFloat(result.votesPercent.toFixed(2)) : 0,
            partyColor: partyFormat ? partyFormat.laSextaColor : result.partyColor
          });
        }) : [];
        dataResult.partiesWinners = dataResult.partiesWinners ? dataResult.partiesWinners.map(result => {
          const partyFormat = partyFormats[result.id];
          return _objectSpread({}, result, {
            partyColor: partyFormat ? partyFormat.laSextaColor : result.partyColor
          });
        }) : [];
        dataResult.updateDate = new Date(dataResult.updateDate).toTimeString().split(" ")[0];
        dataResult.updateDate = dataResult.updateDate !== "Invalid" ? dataResult.updateDate : "00:00";
      }

      if (onlyWinners) {
        setResult(dataResult.partiesWinners);
      } else {
        setResult(dataResult ? _objectSpread({}, dataResult, {
          currentResultRef
        }) : {
          currentResultRef
        });
      }

      Logger.log("ResultProvider.successFunction", "Obitene resultados", dataResult, "Data result");
    };

    Logger.log("ResultProvider.changeSubscribtion", "pide a : ".concat(active ? "firebase" : "amazon"));

    if (active) {
      getFirebaseData([resultRef, resultRef2, resultRef3], successFunction, callAmazon);
    } else {
      callAmazon(successFunction);
    }
  };

  const callAmazon = success => {
    const amazonPath = "".concat(resultEndPoint, "/").concat(year, "/").concat(type, "/").concat(subtype, "/").concat(electionNumber, "/").concat(placeId || "C108/TOTALS");
    Logger.log("ResultProvider.callAmazon", "amazonPath: ".concat(amazonPath));
    Axios.get("".concat(PATH).concat(amazonPath)).then(d => {
      success(d);
    }).catch(err => {// errror
    });
  };

  return children(result);
};